import { ResourceList } from "src/system/ResourceList.tsx";
import { ResourceEnum } from "src/constants/constants.ts";
import * as styles from "./AccountingPostingVacantPositionModuleList.style.ts";
import { Suspense, useState } from "react";
import { isInIframe } from "@exonn/utils";
import type { AccountingPostingPositionResource } from "@exonn/js-sdk/src/namespaces/accounting-posting";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useTranslation } from "react-i18next";
import { useGlobalModuleTabs } from "src/App/useGlobalModuleTabs.ts";
import { FormAction } from "src/components/Form/Form.types.ts";
import { useModuleListActions } from "src/system/useModuleListActions.ts";

export const AccountingPostingVacantPositionModuleList = () => {
  const [selectedRow, setSelectedRow] =
    useState<AccountingPostingPositionResource>();

  const { data: actions } = useModuleListActions({
    resource: ResourceEnum.VacantPosition,
  });

  const { api } = useGlobalModuleTabs();
  const { t } = useTranslation();
  const handleEdit = (row: AccountingPostingPositionResource) => {
    if (isInIframe()) {
      window.parent.postMessage(
        {
          eventName: "OPEN_ERP2_ENTITY",
          payload: {
            resource: ResourceEnum.AccountingPosting,
            type: "edit",
            id: row.accounting_posting_id,
          },
        },
        "https://exonn.online",
      );
    } else {
      api.openTab({
        resource: ResourceEnum.AccountingPosting,
        type: "form",
        action: FormAction.Edit,
        id: row.accounting_posting_id,
      });
    }
  };
  return (
    <Suspense fallback={null}>
      <div css={styles.container}>
        <div css={styles.list}>
          <ResourceList
            onRowDoubleClick={(params) => {
              handleEdit(params.row);
            }}
            actions={actions}
            contextMenu={{
              selectedRow: selectedRow,
              onSelectedRowChange: setSelectedRow,
              items: [
                {
                  label: t("actions.edit", {
                    ns: TranslationNamespaceEnum.Common,
                  }),
                  icon: <i className={"icon-15-edit"} />,
                  key: "edit",
                  onSelect: handleEdit,
                },
              ],
            }}
            hideToolbarCreateNewRecordButton
            resource={ResourceEnum.VacantPosition}
          />
        </div>
      </div>
    </Suspense>
  );
};
